import { render, staticRenderFns } from "./ZonaInner.vue?vue&type=template&id=35d61ada&"
import script from "./ZonaInner.vue?vue&type=script&lang=js&"
export * from "./ZonaInner.vue?vue&type=script&lang=js&"
import style0 from "./ZonaInner.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports